import { ResourceList } from "src/system/ResourceList.tsx";
import { ResourceEnum } from "src/constants/constants.ts";
import { Suspense, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import type { OrderResource } from "@exonn/js-sdk";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import type { GridFilterModel } from "@mui/x-data-grid-premium";
import { useGlobalModuleTabs } from "src/App/useGlobalModuleTabs.ts";
import { FormAction } from "src/components/Form/Form.types.ts";

export const CustomerOrders = () => {
  const { id } = useParams() as { id: string };
  const { t } = useTranslation();
  const { api } = useGlobalModuleTabs();

  const filter = useMemo(
    (): GridFilterModel => ({
      items: [
        {
          field: "customer_id",
          value: id,
          operator: "exact",
        },
      ],
    }),
    [id],
  );

  const [selectedRow, setSelectedRow] = useState<OrderResource | null>(null);

  const openOrder = (resource: OrderResource) => {
    api.openTab({
      resource: ResourceEnum.Order,
      type: "form",
      action: FormAction.Edit,
      id: resource.id,
    });
  };

  const createOrder = () => {
    api.openTab({
      resource: ResourceEnum.Order,
      type: "form",
      action: FormAction.Create,
      searchParams: new URLSearchParams({ customer_id: id }),
    });
  };

  return (
    <Suspense fallback={null}>
      <ResourceList
        style={{
          padding: 15,
        }}
        contextMenu={{
          selectedRow,
          onSelectedRowChange: setSelectedRow,
          items: [
            {
              icon: <span className={"icon-15-edit"} />,
              label: t("actions.edit", {
                ns: TranslationNamespaceEnum.Common,
              }),
              key: "edit",
              onSelect: (row: OrderResource) => {
                openOrder(row);
              },
            },
          ],
        }}
        onRowDoubleClick={({ row }) => {
          openOrder(row);
        }}
        onToolbarCreateNewRecord={createOrder}
        resource={ResourceEnum.Order}
        filter={filter}
      />
    </Suspense>
  );
};
